/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";

export const Gradients: Record<string, string | undefined> = {
  undefined: undefined,
  primary: `linear-gradient(90deg, ${colors.primary400} -1.99%, ${colors.primary500} 50.05%, ${colors.primary700} 104.3%)`,
};
